/**
 * Browser Push Notification utility for Aircom Connect.
 * Requests permission and sends local notifications when order status changes.
 */

let permissionGranted = false;

export async function requestNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') {
    permissionGranted = true;
    return true;
  }
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  permissionGranted = result === 'granted';
  return permissionGranted;
}

export function sendBrowserNotification(title, body, options = {}) {
  if (!permissionGranted && Notification.permission !== 'granted') return;
  try {
    const notif = new Notification(title, {
      body,
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      tag: options.tag || 'aircom-notification',
      ...options,
    });
    if (options.onClick) notif.onclick = options.onClick;
    setTimeout(() => notif.close(), 8000);
  } catch (e) {
    console.warn('Notification failed:', e);
  }
}

/**
 * Poll for new notifications and trigger browser push for unread ones.
 */
export function startNotificationPolling(getAuthHeaders, apiBase, interval = 30000) {
  let lastCheck = new Date().toISOString();

  const check = async () => {
    try {
      const res = await fetch(`${apiBase}/b2b/notifications`, {
        headers: getAuthHeaders(),
      });
      if (!res.ok) return;
      const notifs = await res.json();
      const unread = notifs.filter(n => !n.read && n.created_at > lastCheck);
      for (const n of unread) {
        sendBrowserNotification(n.title, n.message, {
          tag: `aircom-${n.id}`,
        });
      }
      if (notifs.length > 0) {
        lastCheck = new Date().toISOString();
      }
    } catch (err) {
      // Polling is best-effort. Only log in dev to avoid spamming consoles in prod.
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.debug('[notifications] poll failed', err);
      }
    }
  };

  const timerId = setInterval(check, interval);
  check();
  return () => clearInterval(timerId);
}
